import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActivetargetLabel } from '../../actions/deActions/deLabelActions';
import LabelView from '../../components/enablement/LabelView';

const Label = () => {
  const labelState = useSelector(state => state.deLabel);
  const dispatch = useDispatch();

  const _getLabels = () => {
    const { selectedTargets } = labelState;
    if (selectedTargets) {
      dispatch(setActivetargetLabel(selectedTargets));
    }
  };

  React.useEffect(() => {
    _getLabels();
  }, []);

  return (
    <React.Fragment>
      <LabelView />
    </React.Fragment>
  );
};

export default Label;
